/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actions
import { updatePageDetails, changePage } from 'state/actions/app_status';
import { updataDetailDropDown } from 'state/actions/detailViewState/detailViewStatus';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import StoryContentAnalyticsCard from 'material/embeds/contentanalyticscard/story/story';



/* ========== ~~~~~~~~~~ CONTENT CARD : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = () => ({});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToDetailedViewAnalytics: (storyId) => {
        dispatch(updataDetailDropDown([storyId], 'STORY'));
        dispatch(updatePageDetails('dashboard/analytics/detail/storyclicks'));
        dispatch(changePage(`dashboard/analytics/detail/storyclicks`))
    }
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StoryContentAnalyticsCard);